class Favorite
{
    constructor(favoriteLink) {
        this.favoriteLink = favoriteLink
        this.clearLink = this.favoriteLink.nextElementSibling.nextElementSibling
        this.shareLink = this.clearLink.nextElementSibling
        this.favoriteItems = this.getItems()
        this.share = window.Ya ? Ya.share2(this.shareLink, {
            hooks: {
                onshare(name) {
                    $app.runEvent('click', { избранное: { поделиться: name } })
                }
            }
        }) : null

        if (this.favoriteItems.length === 0) {
            this.clearLink.classList.add('d-none')

            if ($app.isMobile) {
                this.favoriteLink.parentNode.remove()
            }
        }

        this.setFavoriteLink()

        this.clearLink.addEventListener('click', event => {
            event.preventDefault()

            swal.fire({
                icon: 'question',
                title: 'Вы уверены?',
                showCancelButton: true,
                confirmButtonText: 'Да',
                cancelButtonText: 'Нет',
                text: 'Будет удалено из избранного заведений: ' + this.favoriteItems.length
            }).then(result => {
                if (result.isConfirmed) {
                    this.favoriteItems = []
                    localStorage.removeItem('favorite')
                    this.clearLink.classList.add('d-none')
                    this.favoriteLink.firstElementChild.textContent = '0'
                    this.favoriteLink.href = this.favoriteLink.nextElementSibling.href = '#'

                    document.querySelectorAll('.place__favorite').forEach(f => {
                        this.setFilled(f, false, false)
                    })
                }
            })
        })
    }

    getItems() {
        return JSON.parse(localStorage.getItem('favorite') || '[]')
    }

    process(container, selector) {
        container.querySelectorAll(selector).forEach(heart => {
            let barId = heart.dataset.id

            if (this.favoriteItems.indexOf(barId) >= 0) {
                this.setFilled(heart, true, false)
            }

            heart.addEventListener('click', () => {
                this.favoriteItems = this.getItems()

                if (this.favoriteItems.indexOf(barId) < 0) {
                    this.favoriteItems.push(barId)
                    this.setFilled(heart)
                } else {
                    this.favoriteItems = this.favoriteItems.filter(id => id != barId)
                    this.setFilled(heart, false)
                }

                this.setFavoriteLink()

                localStorage.setItem('favorite', JSON.stringify(this.favoriteItems))
            })

            heart.dataset.initialized = ''
        });
    }

    setFilled(heart, filled = true, showTooltip = true) {
        heart.classList.add('gbi-heart' + (filled ? '-filled' : ''))
        heart.classList.remove('gbi-heart' + (filled ? '' : '-filled'))

        let link = '<a href="' + this.getHref() + '" class="color-green" onclick="$app.runEvent(\'click\', { избранное: \'в подсказке после добавления\' })">Добавлено в избранное</a>'
        let tooltip = $(heart).tooltipster('content', filled ? link : 'Добавить в избранное')

        if (showTooltip) {
            setTimeout(() => tooltip.tooltipster('open'))
        }
    }

    setFavoriteLink() {
        let href = this.getHref()

        this.shareLink.dataset.url = href
        this.shareLink.classList.toggle('d-none', ! this.favoriteItems.length)
        this.clearLink.classList.toggle('d-none', ! this.favoriteItems.length)

        this.favoriteLink.href = this.favoriteLink.nextElementSibling.href = href
        this.favoriteLink.firstElementChild.textContent = this.favoriteItems.length

        if (this.share) {
            this.share.updateContent({
                url: href,
                title: 'Подборка лучших заведений',
                description: 'Подобрали крутые заведения, зацени :)',
                image: 'https://static.gdebar.ru/data/base/img/logo.png'
            })
        }
    }

    getHref() {
        return this.favoriteItems.length ? $app.urlPrefix + '/luchshie-zavedeniya?from_favorite=1&term=' + this.favoriteItems.join('+') : '#'
    }
}

module.exports = Favorite